import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import styled from 'styled-components';
import { colourWhite, colourPrimary, colourPrimaryLight, colourBlack, colourMasterDarker, colourMaster, colourMasterSemiLight } from 'Styles/colors.css';

const MULTIPLE = 'multiple';

const StyledTags = styled(TagsInput)`
  padding: 0;
  border-radius: 4px;
  display: table;
  border-spacing: 0;
  border-collapse: separate;
  height: 36px;
  overflow: hidden;
  font-size: .9em;

  .react-tagsinput-tag {
    background: ${colourPrimaryLight};
    display: inline-block;
    padding: 4px 8px 3px;
    padding-right: 10px;
    margin-top: 3px;
    margin-left: 5px;
    line-height: 20px;
    border: none;
    border-radius: 6px;
  }

  .react-tagsinput-remove {
    cursor: pointer;
    float: left;
    margin-right: 8px;
    color: #2c2c2c !important;
    font-size: 16px;
    border: none;
  }

  .react-tagsinput-tag {
    a::after {
      content: " ×";
    }
  }

  .react-tagsinput-input {
    margin-left: 5px;
    font-size: 1em;
    line-height: 32px;
    border: none;
  }
`;

class WveInputTags extends Component {
  render() {
    const { value, onChange, placeholder, pattern, onBlur, disabled } = this.props;
    const isMultiple = value === MULTIPLE;
    const patternToUse = isMultiple ? '' : pattern;

    const tagsValue = value || [];
    const sanitizedValue = Array.isArray(tagsValue) ? tagsValue : tagsValue.split(',');

    return (<StyledTags
      className="wve-form-item wve-form-item-long form-control input-sm"
      onChange={onChange}
      value={sanitizedValue}
      inputProps={{ placeholder }}
      disabled={disabled}
      onBlur={onBlur}
    />);
  }
}

WveInputTags.defaultProps = {
  value: '',
  placeholder: '',
  pattern: '',
  onBlur: null,
  disabled: false,
};

WveInputTags.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.Array]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  pattern: PropTypes.string,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

export default WveInputTags;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputTags/WveInputTags.jsx